import Carousel from '../components/Carousel2';
import Simulator from '../components/personas/Simulator';
import FAQSection from '../components/personas/CDTs/FAQ';
import Hero1 from '../components/Hero1';
import HorizontalList from '../components/horizontalList';
import HeroB from '../components/HeroB';
import pareja3 from '../assets/pareja3.jpg';
import funcionamientoImg from '../assets/funcionamiento.png';

function SimulaTuCDT() {
    const carouselItems = [
        { title: "Las mejores tasas del mercado en un solo lugar", description: "Consulta las tasas más competitivas en tiempo real con nuestro simulador CDT, que compara las ofertas de todos los bancos de Colombia." },
        { title: "Abre tu CDT gratis y sin ir al banco", description: "Invierte fácilmente desde tu hogar, sin filas ni citas. Si lo necesitas, vamos a tu casa u oficina para ayudarte con los formularios y los llevamos al banco por ti." },
        { title: "Gestión de vencimientos eficiente", description: "Te ayudamos a gestionar el vencimiento de tu CDT, contactándote un mes antes para planificar su renovación. Monitorea tus inversiones y abre nuevos CDTs sin costo a través de nuestra app o página web." },
        { title: "Retira tus ganancias fácilmente", description: "En caso de vencimiento, accede rápidamente a tus ganancias gracias a nuestros canales digitales." },
        { title: "Atención personalizada", description: "Recibe asesoría personalizada de nuestros expertos para tomar las mejores decisiones de inversión." },
        { title: "Acceso a información en tiempo real", description: "Consulta todos los movimientos de tu CDT y mantente informado en todo momento desde nuestra app." },
    ];

    const navItems = [
        { label: "Inicio", targetId: "inicio" },
        { label: "Simulador", targetId: "simulador" },
        { label: "¿Cómo funciona?", targetId: "como-funciona" },
        { label: "Beneficios", targetId: "beneficios" },
        { label: "Preguntas frecuentes", targetId: "faq" },
    ];

    const comoFuncionaItems = [
        "Simula las tasas de todos los bancos de Colombia en minutos.",
        "Recibe acompañamiento para diligenciar formularios y apertura remota.",
        "Monitorea tus vencimientos con alertas y renueva sin costo adicional."
    ];

    return (
        <div>
            <section id="inicio" className="scroll-mt-48">
                <Hero1
                    imagen={pareja3}
                    titulo="Gestiona tus CDTs"
                    descripcion="En un solo lugar: compara, adquiere y centraliza toda tu información fácilmente."
                />
            </section>
            <HorizontalList items={navItems} />
            <section id="simulador" className="scroll-mt-48">
                <Simulator titulo="Simula tu CDT" tipo="CDT" />
            </section>
            <section id="como-funciona" className="scroll-mt-24">
                <HeroB
                    imagen={funcionamientoImg}
                    titulo="¿Cómo funciona?"
                    items={comoFuncionaItems}
                    botonTexto="Quiero asesoría"
                />
            </section>
            <section id="beneficios" className="scroll-mt-24">
                <Carousel items={carouselItems} />
            </section>
            <section id="faq" className="scroll-mt-24">
                <FAQSection />
            </section>
            <hr className="w-full border-t border-black" />
        </div>
    );
}
export default SimulaTuCDT;
